// Comment Set #1, Pipeline 3: "Update pin/pinned icons to match Figma".
//
// Both states are #4F5F4A in the export and differ only by whether the head is filled — layers
// `icon-pin-default` and `icon-pin-active` in files/sow2-section-lean.svg, each inside its own
// 14x14 clip (`translate(2881.5 1465)` and `translate(2881.5 1321)`). What shipped before was
// #A7C199 unpinned and #547A42 pinned, two greens that appear nowhere in either export except
// inside the Property Dashboard's own hover-state annotation, which is a different button.
//
// The path data below is the export's, translated by subtracting the clip origin — so the glyph is
// the drawn one at the drawn size (12.84 of the 14 box), not the old 12x12 redraw.
// headClassName: a CSS fill on the head path beats its fill attribute, so a parent's group-hover can
// draw the pinned state without a re-render (SOW 4 pin hover).
export function PipelinePinIcon({ active, headClassName }) {
  const stroke = '#4F5F4A'
  const fill   = active ? '#4F5F4A' : 'none'
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_pipe_pin)">
        <path d="M0.58 13.42L4.96 9.04" stroke={stroke} fill="none" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.65 4.43L9.16 7.92C9.55 9.37 9.17 10.98 8.03 12.12L1.88 5.97C3.02 4.83 4.63 4.45 6.08 4.84L9.57 1.35" className={headClassName} stroke={stroke} fill={fill} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.8 0.58L13.42 5.2" stroke={stroke} fill="none" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_pipe_pin">
          <rect width="14" height="14" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}
